module.exports = __webpack_public_path__ + "img/1448.0721a939.gif";